/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Day_TueInputs */

const cs_portals_day_tue = /** @type {(inputs: Portals_Day_TueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Út`)
};

const en_portals_day_tue = /** @type {(inputs: Portals_Day_TueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tue`)
};

/**
* | output |
* | --- |
* | "Tue" |
*
* @param {Portals_Day_TueInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_day_tue = /** @type {((inputs?: Portals_Day_TueInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Day_TueInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_day_tue(inputs)
	return cs_portals_day_tue(inputs)
});